import * as React from 'react';

import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@mui/material';

import { FlightOperationNotificationVersionGroup } from '../../core/api/clients';
import FlightOperationNotificationVersionsTableRow from './FlightOperationNotificationVersionsTableRow';

interface FlightOperationNotificationVersionsTableProps {
  versionGroups: FlightOperationNotificationVersionGroup[];
  latestVersion: number | undefined;
  selectedVersion: number | undefined
}

function FlightOperationNotificationVersionsTable({
  versionGroups,
  latestVersion,
  selectedVersion,
}: FlightOperationNotificationVersionsTableProps) {
  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '8%' }} />
              <TableCell sx={{ width: '8%' }}>Version Number</TableCell>
              <TableCell sx={{ width: '16%' }}>Submitted By</TableCell>
              <TableCell sx={{ width: '16%' }}>Submitted Date</TableCell>
              <TableCell sx={{ width: '22%' }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {versionGroups.map(({ version, auditLogs }) => (
              <FlightOperationNotificationVersionsTableRow
                version={version}
                auditLogs={auditLogs}
                isLatestVersion={version?.versionNumber === latestVersion}
                isSelectedVersion={version?.versionNumber === selectedVersion}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default FlightOperationNotificationVersionsTable;
